export const DISPATCH_PERMISSIONS = {
        viewDispatch: 'dispatch.viewDispatch',
        viewMap: 'dispatch.viewMap',
};

export const FRONTEND_PERMISSIONS = {
        franchiseManagement: 'frontend.franchise-managment',
        franchise: 'frontend.franchise',
        jobs: 'frontend.jobs',
        availability: 'frontend.availability',
        schedule: 'frontend.schedule',
        users: 'frontend.users',
        products: 'frontend.products',
        assets: 'frontend.assets',
        estimating: 'frontend.estimating',
        marketing: 'frontend.marketing',
        reports: 'frontend.reports',
        settings: 'frontend.settings',
        config: 'frontend.config',
        notifications: 'users.viewNotifications',
        needsAttention: 'frontend.needs-attention',
        dashboardBilling: 'dashboard.billing',
        dashboardActivations: 'dashboard.activations',
        dashboardSelfImprovingAI: 'dashboard.self-improving-ai',
        dashboardRevenue: 'dashboard.revenue',
        dashboardEngine: 'dashboard.engine',
        dashboardSalesLeaderboard: 'dashboard.salesLeaderboard',
        dashboardOpsReadiness: 'dashboard.opsReadiness',
        dashboardSystemRevenue: 'dashboard.systemRevenue',
        dashboardOtrLaborTracking: 'dashboard.otrLaborTracking',
        demoMode: 'frontend.demo-mode',
};
